document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const formatMoney = (value) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(value);
    }
    return `${(value / 100).toFixed(2)} kr`;
  };

  // Reveal-on-scroll animations
  const revealTargets = document.querySelectorAll('section, .section, .product, .collection-card, .product-card, .blog-card, .hero, .hero-goal, .hero-plan, .value-columns, .cart, .cart-drawer, .footer, .product__card, .ritual-card');
  if (revealTargets.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealTargets.forEach((el, idx) => {
      el.classList.add('revealable');
      el.style.transitionDelay = '0ms';
      observer.observe(el);
    });
  }

  const mobileToggles = document.querySelectorAll('[data-mobile-toggle]');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileClose = document.querySelector('[data-mobile-close]');
  if (mobileToggles.length && mobileMenu) {
    const toggleMobile = (open) => {
      mobileMenu.hidden = !open;
      mobileToggles.forEach(btn => btn.setAttribute('aria-expanded', String(open)));
      body.classList.toggle('no-scroll', open);
    };
    mobileToggles.forEach(btn => btn.addEventListener('click', () => toggleMobile(true)));
    mobileClose?.addEventListener('click', () => toggleMobile(false));
  }

  const drawer = document.getElementById('cart-drawer');
  const cartToggle = document.querySelectorAll('[data-cart-toggle]');
  const cartClose = document.querySelector('[data-cart-close]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartItems = document.querySelector('[data-cart-items]');
  const cartSubtotal = document.querySelector('[data-cart-subtotal]');
  const cartCount = document.querySelector('[data-cart-count]');

  const openCart = async () => {
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      try {
        const cart = await fetchCart();
        renderCart(cart);
      } catch (e) {
        // silent fail; keep drawer open
      }
    }
  };
  const closeCart = () => drawer?.setAttribute('aria-hidden', 'true');

  cartToggle.forEach((btn) => btn.addEventListener('click', openCart));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  let cartUpdating = false;
  async function changeCartLine(line, quantity) {
    if (cartUpdating) return;
    cartUpdating = true;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ line, quantity })
      });
      if (!res.ok) {
        const error = await res.json();
        alert(error.description || 'Unable to update cart.');
        return;
      }
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {
      alert('Unable to update cart.');
    } finally {
      cartUpdating = false;
    }
  }

  function renderCart(cart) {
    if (!cartItems || !cartSubtotal || !cartCount) return;
    if (cart.items.length === 0) {
      cartItems.innerHTML = `<p class="muted">${window.themeStrings.cartEmpty}</p>`;
      cartItems.classList.add('is-empty');
    } else {
      cartItems.classList.remove('is-empty');
      cartItems.innerHTML = cart.items.map((item, index) => `
        <div class="cart-line" data-cart-line="${index + 1}">
          <img src="${item.image || ''}" alt="${item.title}">
          <div>
            <p class="cart-line__title"><a href="${item.url}">${item.product_title}</a></p>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="muted">${item.variant_title}</p>` : ''}
            <div class="cart-line__meta">
              <div class="qty">
                <span class="sr-only">${window.themeStrings.quantityLabel}</span>
                <div class="qty__controls">
                  <button type="button" data-cart-qty-change="-1" aria-label="${window.themeStrings.decreaseQty}">-</button>
                  <input type="number" min="0" value="${item.quantity}" data-cart-qty-input>
                  <button type="button" data-cart-qty-change="1" aria-label="${window.themeStrings.increaseQty}">+</button>
                </div>
              </div>
              <button class="cart-line__remove" type="button" data-cart-remove aria-label="${window.themeStrings.removeItem}">
                ${window.themeStrings.removeItem}
              </button>
            </div>
          </div>
          <div class="cart-line__price">${formatMoney(item.line_price)}</div>
        </div>
      `).join('');
    }
    cartSubtotal.textContent = formatMoney(cart.total_price);
    cartCount.textContent = cart.item_count;
    document.dispatchEvent(new Event('cart:updated'));
  }

  async function addToCart(form) {
    const data = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    });
    if (!res.ok) {
      const error = await res.json();
      alert(error.description || 'Unable to add to cart.');
      return;
    }
    const cart = await fetchCart();
    renderCart(cart);
    openCart();
  }
  // Sync cart state on load for badge/drawer contents
  fetchCart().then(renderCart).catch(() => {});

  cartItems?.addEventListener('click', (e) => {
    const changeBtn = e.target.closest('[data-cart-qty-change]');
    if (changeBtn) {
      const lineEl = changeBtn.closest('[data-cart-line]');
      if (!lineEl) return;
      const input = lineEl.querySelector('[data-cart-qty-input]');
      if (!input) return;
      const delta = parseInt(changeBtn.dataset.cartQtyChange || '0', 10);
      const next = Math.max(0, parseInt(input.value || '0', 10) + delta);
      input.value = next;
      changeCartLine(parseInt(lineEl.dataset.cartLine, 10), next);
      return;
    }
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      const lineEl = removeBtn.closest('[data-cart-line]');
      if (!lineEl) return;
      changeCartLine(parseInt(lineEl.dataset.cartLine, 10), 0);
    }
  });

  cartItems?.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    const lineEl = input.closest('[data-cart-line]');
    if (!lineEl) return;
    const value = Math.max(0, parseInt(input.value || '0', 10));
    input.value = value;
    changeCartLine(parseInt(lineEl.dataset.cartLine, 10), value);
  });

  document.querySelectorAll('[data-product-atc]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(form);
    });
  });

  document.querySelectorAll('[data-product-card-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(form);
    });
  });

  document.querySelectorAll('[data-qty-change]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty__controls').querySelector('[data-qty-input]');
      const delta = parseInt(btn.dataset.qtyChange, 10);
      input.value = Math.max(1, parseInt(input.value || '1', 10) + delta);
    });
  });

  const optionInputs = document.querySelectorAll('[data-variant-option]');
  if (optionInputs.length) {
    const variantData = JSON.parse(document.querySelector('[data-product-form]').dataset.variants || '[]');
    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const selections = Array.from(document.querySelectorAll('[data-variant-option]:checked')).map(el => el.value);
        const match = variantData.find(v => JSON.stringify(v.options) === JSON.stringify(selections));
        if (match) {
          document.querySelector('[data-variant-id]').value = match.id;
          document.querySelector('[data-product-price]').innerHTML = formatMoney(match.price);
          const sku = document.querySelector('[data-sku]');
          if (sku) sku.textContent = match.sku || '';
          const availability = document.querySelector('[data-availability]');
          if (availability) availability.textContent = match.available ? window.themeStrings.inStock : window.themeStrings.outOfStock;
        }
      });
    });
  }

  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterChips = document.querySelector('[data-filter-chips]');
  if (filterToggle && filterChips) {
    filterToggle.addEventListener('click', () => {
      const isHidden = filterChips.hasAttribute('hidden');
      filterChips.toggleAttribute('hidden', !isHidden);
    });
    filterChips.addEventListener('click', (e) => {
      const btn = e.target.closest('.chip');
      if (!btn) return;
      filterChips.querySelectorAll('.chip').forEach(c => c.classList.remove('is-active'));
      btn.classList.add('is-active');
      const tag = btn.dataset.tag;
      document.querySelectorAll('[data-product-card]').forEach((card) => {
        if (tag === 'all' || card.dataset.tags?.includes(tag)) {
          card.hidden = false;
        } else {
          card.hidden = true;
        }
      });
    });
  }

  const slideshow = document.querySelector('[data-slideshow]');
  if (slideshow) {
    const track = slideshow.querySelector('.slideshow__track');
    const slides = Array.from(slideshow.querySelectorAll('.slideshow__slide'));
    if (!slides.length) return;
    let index = 0;
    const update = () => {
      track.style.transform = `translateX(-${index * 100}%)`;
    };
    slideshow.querySelector('[data-slide-next]')?.addEventListener('click', () => {
      index = (index + 1) % slides.length;
      update();
    });
    slideshow.querySelector('[data-slide-prev]')?.addEventListener('click', () => {
      index = (index - 1 + slides.length) % slides.length;
      update();
    });
    setInterval(() => {
      index = (index + 1) % slides.length;
      update();
    }, 5000);
  }

  const thumbs = document.querySelectorAll('[data-gallery-thumbs] .product__thumb');
  const mainImage = document.querySelector('[data-gallery-main]');
  if (thumbs.length && mainImage) {
    const updateMainFromIndex = (index) => {
      const thumb = thumbs[index];
      if (!thumb) return;
      const media = thumb.dataset.mediaSrc;
      const zoomSrc = thumb.dataset.mediaZoom;
      const altText = thumb.getAttribute('aria-label') || '';
      const img = mainImage.querySelector('img');
      if (media && img) {
        img.classList.add('is-transitioning');
        requestAnimationFrame(() => {
          img.style.opacity = '0';
          setTimeout(() => {
            img.src = media;
            if (zoomSrc) img.dataset.zoom = zoomSrc;
            if (altText) img.alt = altText;
            mainImage.dataset.currentIndex = index;
            img.onload = () => {
              img.style.opacity = '';
              img.classList.remove('is-transitioning');
              img.onload = null;
            };
          }, 120);
        });
      }
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = parseInt(thumb.dataset.thumbIndex || '0', 10);
        updateMainFromIndex(index);
      });
    });

    const prev = document.querySelector('[data-gallery-prev]');
    const next = document.querySelector('[data-gallery-next]');
    const total = thumbs.length;

    const goTo = (delta) => {
      const current = parseInt(mainImage.dataset.currentIndex || '0', 10);
      const nextIndex = (current + delta + total) % total;
      updateMainFromIndex(nextIndex);
    };

    prev?.addEventListener('click', (e) => {
      e.stopPropagation();
      goTo(-1);
    });
    next?.addEventListener('click', (e) => {
      e.stopPropagation();
      goTo(1);
    });

    // Swipe / drag navigation
    let swipeStartX = 0;
    let isSwiping = false;
    const swipeThreshold = 24;

    const handlePointerDown = (clientX, target) => {
      if (target.closest('button')) return; // ignore nav clicks
      isSwiping = true;
      swipeStartX = clientX;
    };
    const handlePointerEnd = (clientX) => {
      if (!isSwiping) return;
      const delta = clientX - swipeStartX;
      if (Math.abs(delta) > swipeThreshold) {
        goTo(delta > 0 ? -1 : 1);
      }
      isSwiping = false;
    };

    mainImage.addEventListener('pointerdown', (e) => handlePointerDown(e.clientX, e.target));
    mainImage.addEventListener('pointerup', (e) => handlePointerEnd(e.clientX));
    mainImage.addEventListener('pointerleave', (e) => handlePointerEnd(e.clientX));
    mainImage.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      if (touch) handlePointerDown(touch.clientX, e.target);
    }, { passive: true });
    mainImage.addEventListener('touchend', (e) => {
      const touch = e.changedTouches[0];
      if (touch) handlePointerEnd(touch.clientX);
    });

    // Prevent native dragging from hijacking swipe
    const mainImgEl = mainImage.querySelector('img');
    if (mainImgEl) {
      mainImgEl.addEventListener('dragstart', (ev) => ev.preventDefault());
    }
  }

  const buyNowBtn = document.querySelector('[data-buy-now]');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', async () => {
      const form = document.querySelector('[data-product-atc]');
      if (!form) return;
      const data = new FormData(form);
      const qtyInput = form.querySelector('[data-qty-input]');
      if (qtyInput) data.set('quantity', qtyInput.value || '1');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: data
        });
        if (!res.ok) {
          const error = await res.json();
          alert(error.description || 'Unable to start checkout.');
          return;
        }
        window.location.href = '/checkout';
      } catch (err) {
        console.error(err);
        alert('Unable to start checkout. Please try again.');
      }
    });
  }

  // --- START AV NY LIGHTBOX-KOD MED SWIPE ---
  const lightboxTriggers = document.querySelectorAll('.product__media img, .product-single__media img, .product-gallery img');
  if (lightboxTriggers.length) {
    // 1. Skapa en lista med alla bildkällor
    const allImages = Array.from(lightboxTriggers).map(trigger => {
        const img = trigger.tagName === 'IMG' ? trigger : trigger.querySelector('img');
        return {
            src: img.dataset.zoom || img.src,
            alt: img.alt || ''
        };
    });

    let currentIndex = 0; 

    const lightbox = document.createElement('div');
    lightbox.className = 'lightbox';
    
    // 2. Vi lägger till knappar i HTML
    lightbox.innerHTML = `
      <div class="lightbox__content">
        <button class="lightbox__close" type="button" aria-label="Close">&times;</button>
        <button class="lightbox__prev" type="button" aria-label="Previous">&#10094;</button>
        <img alt="">
        <button class="lightbox__next" type="button" aria-label="Next">&#10095;</button>
      </div>
    `;
    document.body.appendChild(lightbox);

    const lightboxImg = lightbox.querySelector('img');

    // Funktion för att byta bild
    const updateImage = (index) => {
        if (index < 0) index = allImages.length - 1; 
        if (index >= allImages.length) index = 0;    
        
        currentIndex = index;
        lightboxImg.src = allImages[currentIndex].src;
        lightboxImg.alt = allImages[currentIndex].alt;
    };

    const closeLightbox = () => {
      lightbox.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    };

    // Klick-lyssnare (Knappar)
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox || e.target.closest('.lightbox__close')) {
        closeLightbox();
      } else if (e.target.closest('.lightbox__prev')) {
          updateImage(currentIndex - 1);
      } else if (e.target.closest('.lightbox__next')) {
          updateImage(currentIndex + 1);
      }
    });

    // Tangentbord
    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') updateImage(currentIndex - 1);
      if (e.key === 'ArrowRight') updateImage(currentIndex + 1);
    });

    // SWIPE-FUNKTION (Touch)
    let touchStartX = 0;
    let touchEndX = 0;

    lightbox.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    lightbox.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    const handleSwipe = () => {
      const threshold = 50; 
      if (touchStartX - touchEndX > threshold) updateImage(currentIndex + 1); // Swipe Vänster
      if (touchEndX - touchStartX > threshold) updateImage(currentIndex - 1); // Swipe Höger
    };

    // Klick på miniatyrer
    lightboxTriggers.forEach((trigger, index) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        updateImage(index);
        lightbox.classList.add('is-open');
        document.body.classList.add('no-scroll');
      });
    });
  }
  // --- SLUT PÅ NY LIGHTBOX-KOD ---

  async function addBundle(variantIds = []) {
    const items = variantIds.filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
    if (!items.length) return;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });
    if (!res.ok) {
      const error = await res.json();
      alert(error.description || 'Unable to add bundle to cart.');
      return;
    }
    const cart = await fetchCart();
    renderCart(cart);
    openCart();
  }

  const goalButtons = document.querySelectorAll('[data-hero-goal]');
  const plans = document.querySelectorAll('[data-hero-plan]');
  const plansWrapper = document.querySelector('[data-hero-plans]');
  const progressBar = document.querySelector('[data-hero-progress]');
  const panelList = document.querySelector('[data-hero-list]');
  const backButtons = document.querySelectorAll('[data-hero-back]');
  let planVisible = false;

  const showPlan = (target) => {
    if (!target) return;
    if (!planVisible) {
      plansWrapper?.classList.remove('is-hidden');
      panelList?.classList.add('is-hidden');
      planVisible = true;
    }
    goalButtons.forEach((g) => {
      const isActive = g.dataset.goalTarget === target;
      g.classList.toggle('is-active', isActive);
      g.setAttribute('aria-selected', String(isActive));
    });
    plans.forEach((plan) => {
      plan.classList.toggle('is-hidden', plan.id !== target);
    });
    if (progressBar) {
      progressBar.style.width = planVisible ? '100%' : '0%';
    }
  };

  const showList = () => {
    planVisible = false;
    plansWrapper?.classList.add('is-hidden');
    panelList?.classList.remove('is-hidden');
    if (progressBar) progressBar.style.width = '0%';
  };

  if (goalButtons.length && plans.length) {
    goalButtons.forEach((goal) => {
      goal.addEventListener('click', () => showPlan(goal.dataset.goalTarget));
    });
    backButtons.forEach((btn) => btn.addEventListener('click', showList));
    if (progressBar) progressBar.style.width = '0%';
  }

  document.querySelectorAll('[data-quickstart-add]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const ids = btn.dataset.variantIds ? btn.dataset.variantIds.split(',').filter(Boolean) : [];
      addBundle(ids);
    });
  });

  document.querySelectorAll('[data-quickstart-single]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.variantId;
      if (!id) return;
      addBundle([id]);
    });
  });

  // Account menu toggle (improves usability vs hover-only)
  const accountTriggers = document.querySelectorAll('.nav-account__trigger');
  const accounts = document.querySelectorAll('.nav-account');
  if (accountTriggers.length) {
    accountTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        const parent = trigger.closest('.nav-account');
        const hasMenu = parent?.querySelector('.nav-account__menu');
        if (!parent || !hasMenu) return; // allow logged-out link to navigate
        e.preventDefault();
        const isOpen = parent.classList.contains('is-open');
        accounts.forEach((acc) => acc.classList.remove('is-open'));
        if (!isOpen) {
          parent.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
    document.addEventListener('click', (e) => {
      if (e.target.closest('.nav-account')) return;
      accounts.forEach((acc) => {
        acc.classList.remove('is-open');
        const trg = acc.querySelector('.nav-account__trigger');
        if (trg) trg.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') accounts.forEach((acc) => {
        acc.classList.remove('is-open');
        const trg = acc.querySelector('.nav-account__trigger');
        if (trg) trg.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Header alt hide/reveal on scroll
  // Handled by inline script in header-alt.liquid (uses .header-hidden class)
  // Removed duplicate handler that conflicted with threshold-based show logic
});